import { useState } from 'react';
import { useInterval } from 'react-use';
import styled from 'styled-components';

const Root = styled.div`
  height: var(--half-unit);
  border-radius: var(--unit);
  background-color: var(--c-nd-200);
`;
const DurationProgress = styled.div`
  height: 100%;
  border-radius: var(--unit);
  background-color: var(--c-nd-700);
`;

export enum StoryStatus {
  SEEN,
  NOT_SEEN,
}

const INTERVAL = 10;

type Props = {
  playing: boolean;
  duration: number;
  onFinish: () => void;
  storyStatus?: StoryStatus;
  pause?: boolean;
};
export const DurationIndicator = ({
  playing,
  duration,
  onFinish,
  storyStatus,
  pause,
}: Props) => {
  const [timeElapsed, setTimeElapsed] = useState(0);

  useInterval(
    () => {
      const newTimeElapsed = timeElapsed + INTERVAL / 1000;
      if (newTimeElapsed >= duration) {
        setTimeElapsed(duration);
        onFinish();
        return;
      }
      setTimeElapsed(newTimeElapsed);
    },
    !pause && playing && timeElapsed < duration ? INTERVAL : null
  );

  let width = Math.min(100, (timeElapsed * 100) / duration);
  if (storyStatus === StoryStatus.SEEN) {
    width = 100;
  } else if (storyStatus === StoryStatus.NOT_SEEN) {
    width = 0;
  }

  return (
    <Root>
      <DurationProgress style={{ width: `${width}%` }} />
    </Root>
  );
};
